export const initialColumnWidth = {
    'product_image':70,
    'product_details':400,
    'quantity':90
}

export const baseColumnOptions = {
    hideSortIcons: true,
    disableColumnMenu: true
}

export const REVOKE_ORDER_RETURN_REASON = "R10";